module.exports = __webpack_public_path__ + "static/media/bpause.bf17f891.svg";